import { takeLatest, put, all, call } from 'redux-saga/effects';

import advanceCollectionActionTypes from './advance-collection.types';
import {
	fetchAdvancehMemberLoanList,
	advanceCollectionUpdateAPI,
} from './advance-collection.service';

import {
	fetchAdvanceMemberLoanInfoSuccess,
	fetchAdvanceMemberLoanInfoFailure,
	fetchAdvanceMemberLoanInfoResponseChanged,
	updateAdvanceCollectionResponseChanged,
	updateAdvanceCollectionSuccess,
	updateAdvanceCollectionFailure,
} from './advance-collection.action';

import { encryptData } from '../../../_common/enode-decode';

import AlertManager from '../../../../utils/alertManager';
/** *********************  START MEMBER LOAN LIST DETAILS  ******************** */
export function* getAdvanceMemberLoanList({ payload }: any) {
	try {
		const key = 'FetchAdvanceMemberListDataKey';
		const jsonData = {
			GroupOfficerID: payload.officerID,
			DatabaseName: payload.DatabaseName,
			FromDate: payload.FromDate,
			ToDate: payload.FromDate,
			CompanyID: payload.CompanyID,
			BranchID: payload.BranchID,
			LocationID: payload.CenterID,
			GroupID: payload.GroupID,
			UserLevel: payload.UserLevel,
			RepayDate: payload.FromDate,
			IsArrearAdvanceCollection: false,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchAdvancehMemberLoanList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAdvanceMemberLoanInfoFailure(responseData.data));
		} else {
			yield put(fetchAdvanceMemberLoanInfoSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAdvanceMemberLoanInfoFailure(error));
	}
}

export function* resetGetAdvanceMemberLoanListResponse() {
	yield put(fetchAdvanceMemberLoanInfoResponseChanged());
}

export function* onGetAdvanceMemberLoanListDetails() {
	yield takeLatest(
		advanceCollectionActionTypes.GET_ADVANCE_MEMBER_LOAN_LIST_START,
		getAdvanceMemberLoanList,
	);
}

export function* onGetAdvanceMemberLoanListResponseReset() {
	yield takeLatest(
		advanceCollectionActionTypes.GET_ADVANCE_MEMBER_LOAN_LIST_RESPONSE_RESET,
		resetGetAdvanceMemberLoanListResponse,
	);
}
/** *********************  END GET MEMBER LOAN LIST  ******************** */

/** *********************  START ADVANCE COLLECTION UPDATE  ******************** */
export function* updateAdvanceCollectionList({ payload }: any) {
	try {
		const key = 'UpdateAdvanceCollectionDataKey';
		const CollectionLoanArr = JSON.stringify(payload.collectionLoanArr).replace(/"/g, "'");
		const {
			companyID,
			userID,
			userName,
			branchID,
			centerID,
			groupID,
			CollectionDate,
			databaseName,
			fiveHundred,
			twoHundred,
			hundred,
			fifty,
			twenty,
			ten,
			five,
			two,
			one,
			totalDenomination,
			isAllCenter,
			isGroup,
			paymentFrom,
			paymentMethod,
			selectLoanTab,
			receiptNumber,
			chequeNumber,
			arrearCollectionDate,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			CollectionLoanArr,
			CollectionDate,
			DatabaseName: databaseName,
			UserID: userID,
			UserName: userName,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			twoThousand: 0,
			fiveHundred,
			twoHundred,
			hundred,
			fifty,
			twenty,
			ten,
			five,
			two,
			one,
			TotalDenomination: totalDenomination,
			IsAllCenter: isAllCenter,
			IsGroup: isGroup,
			collectionPage: paymentFrom,
			paymentMethod,
			LoanType: selectLoanTab,
			arrearCollectionDate: arrearCollectionDate,
			receiptNumber: receiptNumber,
			chequeNumber: chequeNumber,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(advanceCollectionUpdateAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateAdvanceCollectionFailure(responseData.data));
		} else {
			yield put(updateAdvanceCollectionSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateAdvanceCollectionFailure(error));
	}
}

export function* resetAdvanceCollectionUpdateResponse() {
	yield put(updateAdvanceCollectionResponseChanged());
}

export function* onAdvanceCollectionUpdate() {
	yield takeLatest(
		advanceCollectionActionTypes.UPDATE_ADVANCE_COLLECTION_START,
		updateAdvanceCollectionList,
	);
}

export function* onAdvanceCollectionUpdateResponseReset() {
	yield takeLatest(
		advanceCollectionActionTypes.UPDATE_ADVANCE_COLLECTION_RESPONSE_RESET,
		resetAdvanceCollectionUpdateResponse,
	);
}
/** *********************  END ADVANCE COLLECTION UPDATE  ******************** */

export function* advanceCollectionSaga() {
	yield all([
		call(onGetAdvanceMemberLoanListDetails),
		call(onGetAdvanceMemberLoanListResponseReset),
		call(onAdvanceCollectionUpdate),
		call(onAdvanceCollectionUpdateResponseReset),
	]);
}
